export default "__VITE_ASSET__qc_M6UXU__"